<script setup>
import {
  originalCountries,
} from '~/assets/jsons/originalParams.json';




const route = useRoute();
const { country } = route.params;
const { t } = useI18n();
const localePath = useLocalePath();

const originalCountry = originalCountries[country];

</script>

<template>
  <section
    class="bg-gradient-to-r from-[var(--p-primary-600)] to-[var(--p-primary-800)] py-16 text-white md:py-24"
  >
    <div class="container mx-auto px-4 text-center">
      <h2
      data-aos="fade-up"
      class="mb-6 text-3xl font-bold">
        {{ t(`pages.profession.cta.title`) }}
      </h2>
      <p
      data-aos="fade-up"
      class="mx-auto mb-8 max-w-3xl text-xl">
        {{ t(`lawyerCountries.${originalCountry}.cta`) }}
      </p>
      <div
      data-aos="fade-up"
      >
        <PrimeButton
          as="router-link"
          :to="
            localePath({
              name: 'chat-profession',
              params: { profession: $t('routes.professions.lawyer') },
            })
          "
          :label="$t('pages.profession.cta.startLegalConsultation')"
          icon="pi pi-arrow-right"
          icon-pos="right"
          size="large"
          class="px-8 py-3"
        />
      </div>
    </div>
  </section>
</template>
